import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";

import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";




import oil1 from "assets/img/oil1.jpg";
import oil2 from "assets/img/oil2.jpg";


class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
            
                   <div>
                    <img
                      src={oil1}
                      alt="Oil "
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Piping System in Refinery Plant
                      </h4>
                    </div>
                  </div>

                     <div>
                    <img
                      src={oil2}
                      alt="Oil "
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Switchgear in Substation
                      </h4>
                    </div>
                  </div>



                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/OilPage/Sections/SectionCarousel.jsx